const l = {
  fit: "scale-down",
  format: "auto"
}, d = "cdn-cgi/image", i = "dxcloud.episerver.net", u = (o, n) => {
  if (!o)
    return;
  if (o.indexOf(i) > -1)
    return o;
  const e = {
    ...l,
    ...n
  };
  let r = [];
  for (const [a, f] of Object.entries(e))
    r.push(`${a}=${f}`);
  const t = new URL(o), s = `${t.protocol}//${t.host}`, c = t.pathname;
  return `${s}/${d}/${r.join(",")}${c}`;
}, m = {
  cloudflare: u
}, O = (o) => o && o >= 2 ? "lazy" : "eager";
export {
  u as cloudflareTransform,
  O as getImageLoading,
  m as imageTransformer
};
